/* eslint-disable no-restricted-syntax */

import { useEffect, useRef } from 'react'
import useDimmed from '@hooks/Interface/useDimmed'
import { useDarkModeControl } from '@hooks/useDarkModeControl'

/**
 * 공통 댓글에서 사용하는 모달이 dom에 노출되었을때 동작하는 interface 로직
 */
const useCommentModal = () => {
	const rafId = useRef<number | null>(null)
	const { darkMode: isDark } = useDarkModeControl()
	const { setDefaultDimmed, setDimmedForDeviceType } = useDimmed()

	useEffect(() => {
		const observer = new MutationObserver((mutations) => {
			if (rafId.current !== null) {
				cancelAnimationFrame(rafId.current)
			}

			/** 한 프레임에서만 동작되도록 처리 (성능) */
			rafId.current = requestAnimationFrame(() => {
				for (const mutation of mutations) {
					/** 다음 이벤트 루프에서 바로 실행되도록 처리 */
					setTimeout(() => {
						const added = Array.from(mutation.addedNodes).some(
							(node) =>
								node instanceof HTMLElement &&
								node.querySelector('.react-responsive-modal-root'),
						)
						const removed = Array.from(mutation.removedNodes).some(
							(node) =>
								node instanceof HTMLElement &&
								!node.querySelector('.react-responsive-modal-root'),
						)

						if (added) {
							setDimmedForDeviceType({ opacity: 0.6 })
						}
						if (removed) {
							setDefaultDimmed()
						}
					})
				}
			})
		})

		observer.observe(document.body, {
			childList: true,
			subtree: false,
		})

		return () => {
			observer.disconnect()
		}
	}, [isDark, setDefaultDimmed, setDimmedForDeviceType])
}
export default useCommentModal
